import React from 'react'
import ReactDOM from 'react-dom'
import { QueryClient, QueryClientProvider} from "react-query";
import './index.css'
import App from './App'

const queryClient = new QueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
  document.getElementById('root')
)
